import { remoteFilePath } from "./remoteFilePath"

export const submitMapper = (values) => {
  return {
    tgl_permintaan_perubahan_data_master: values.tgl_permintaan_perubahan_data_master,
    urgensi: values.urgensi,
    deskripsi: values.deskripsi,
    detail: values.detail.map(d => ({
      kode_modul: d.kode_modul,
      kode_menu: d.kode_menu,
      no_referensi_transaksi: d.no_referensi_transaksi,
      gambar: d.gambar.map(g => remoteFilePath(g.link).path),
      file: d.file.map(f => remoteFilePath(f.link).path),
      atribut: d.atribut.map(a => ({
        atribut_salah: a.atribut_salah,
        nilai_sebelum: a.nilai_sebelum,
        nilai_diminta: a.nilai_diminta,
        alasan_pengubahan: a.alasan_pengubahan,
      }))
    }))
  }
}